"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTitlesHistoryReducer = void 0;

var Immutable = require("seamless-immutable");

var redux_ts_simple_1 = require("redux-ts-simple");

var TitleHubActions_1 = require("../../actions/TitleHubActions");

var INITIAL_STATE = Immutable({
  inProgress: false
});
exports.fetchTitlesHistoryReducer = new redux_ts_simple_1.ReducerBuilder(INITIAL_STATE).on(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryInProgress, function (state, action) {
  return state.merge({
    inProgress: action.payload
  });
}).on(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryCompleted, function (state, action) {
  return state.merge({
    titlesInfo: action.payload
  }, {
    deep: true
  });
}).build();